enum TipoDocumentoUpload {
  Laudo = 'Laudo',
  LaudoAnestesista = 'LaudoAnestesista',
  CotacaoOpme = 'CotacaoOpme',
  GuiaAutorizacaoDoRoboAutorizacao = 'GuiaAutorizacaoDoRoboAutorizacao',
  PendenciaHospital = 'PendenciaHospital',
  AnexoOperadora = 'AnexoOperadora',
  Assinatura = 'Assinatura',
  OrcamentoDeCirurgiaParticular = 'OrcamentoDeCirurgiaParticular',
  DocumentacaoPaciente = 'DocumentacaoPaciente',
  OrcamentoDeCirurgiaParticularAprovado = 'OrcamentoDeCirurgiaParticularAprovado',
  GuiaTissInternacao = 'GuiaTissInternacao',
  GuiaTissOpme = 'GuiaTissOpme',
  SolicitacaoReservaDeSangue = 'SolicitacaoReservaDeSangue',
  DocumentosDiversos = 'DocumentosDiversos',
  TermoDeConsentimento = 'TermoDeConsentimento',
  RequisicaoCotacao = 'RequisicaoCotacao',
  Resumo = 'Resumo',
  JustificativaMedicoNaoSegueOProtocolo = 'JustificativaMedicoNaoSegueOProtocolo',
  PedidoMedicoSemAssinatura = 'PedidoMedicoSemAssinatura',
  PedidoMedico = 'PedidoMedico',
  AnexoDoChatHospital = 'AnexoDoChatHospital',
  AnexoDoChatMedico = 'AnexoDoChatMedico',
  AvaliacaoRiscoPreOperatoria = 'AvaliacaoRiscoPreOperatoria',
}

export default TipoDocumentoUpload
